<!-- eslint-disable -->
<template lang="pug">
    cs-loader(v-if="isLoading")
    .start-page(
        v-else-if="level",
        :class="{'start-page--started': isStarted}"
    )
        transition(
            name="fade",
            enterActiveClass="change-phrase--enter-active",
            enterClass="change-phrase--enter",
            enterToClass="change-phrase--enter-to",
            leaveActiveClass="change-phrase--leave-active",
            leaveClass="change-phrase--leave",
            leaveToClass="change-phrase--leave-to"
        )
            finish-modal(v-if="showFinishModal")
        .start-page__container(v-if="isRealTime && currentStage && !currentStage.isStarted")
            stage-waiting.start-page__box
                .start-page__timer(v-if="currentStage.secondsToStart > 0")
                    span.start-page__timer-title {{ $i18n.t('olympiads.olympiads_startPage_beforeStartNewStage') }}:
                    p.start-page__timer-time {{ timeToStart }}
                cs-button(v-else, @click="currentStage.isStarted = true; setGame()") {{ $i18n.t('olympiads.olympiads_showPage_start') }}
        template(v-else-if="currentGame")
            browse-games(
                v-if="!isStarted",
                :type="gameType",
                :isOlympiad="true",
                :exerciseId="currentGame.id",
                @start="startGame"
            )
            .start-page__container.start-page__games-wrapper(v-else)
                games-wrapper.trainer-wrapper.game-content.olympiad-game(
                    :type="gameType",
                    :exerciseId="currentGame.id",
                    :showTurtle="false",
                    :parameters="{}",
                    gameType="olympiad",
                    :answerDuration="level.answerDuration",
                    @finish="finishExercise"
                )
        .start-page__container.start-page__olympiad-box(v-else)
            olympiad-box.start-page__box
                olympiad-preview-with-decorations(slot="top", :olympiad="level.olympiad", :withoutDate="true")
                    template(v-if="isLevelCompleted")
                        span {{ $i18n.t('olympiads.' + ((isTrainer || isTrainerAvailable) ? 'olympiads_startPage_allTrainerStagesWasComplete' : 'olympiads_startPage_allStagesWasComplete')) }}
                    template(v-else-if="isRealTime")
                        br
                        | {{ $i18n.t('olympiads.olympiads_startPage_completeBeforeTheRest') }}
                        br
                        | {{ currentStage.position + 1 }}
                        | {{ $i18n.t('olympiads.olympiads_startPage_stageWasEnd') }}
                        | {{ currentStage.endTime }}
                        | {{ $i18n.t('olympiads.olympiads_startPage_timezone') }}
                    template(v-else)
                        span
                            | {{ $i18n.t('olympiads.olympiads_startPage_havePassed') }}
                            | {{ currentStage.position + 1 }}
                            | {{ $i18n.t('olympiads.olympiads_startPage_havePassedStage') }}
                .start-page__buttons(slot="bottom")
                    template(v-if="isLevelCompleted")
                        div {{ $i18n.t('olympiads.' + ((isTrainer || isTrainerAvailable) ? 'olympiads_startPage_canSeeResultsInProgress' : 'olympiads_startPage_canSeeResults')) }}
                        .start-page__buttons-container
                            cs-button.start-page__button(@click="$router.push({name: 'dashboard'})")
                                | {{ $i18n.t('common.common_navigation_exit') }}
                            cs-button.start-page__button(v-if="isTrainerAvailable" @click="startTrainerStagesAgain")
                                | {{ $i18n.t('olympiads.olympiads_startPage_startTrainerStageAgain') }}
                    cs-button.start-page__button(@click="setParameters", v-else) {{ $i18n.t('olympiads.olympiads_startPage_nextStage') }}
</template>

<script>
    /*eslint-disable*/
    import LevelApi from '../../api/olympiads/level'
    import StageApi from '../../api/olympiads/stage'
    import _ from 'lodash'
    import GamesWrapper from '../trainer/games/GamesWrapper.vue'
    import {mapState} from 'vuex'
    import OlympiadBox from './Box.vue'
    import OlympiadPreviewWithDecorations from './PreviewWithDecorations.vue'
    import OlympiadPreview from './Preview.vue'
    import moment from "moment";
    import BrowseGames from '../trainer/browse/BrowseGames.vue'
    import FinishModal from './modals/FinishModal.vue'
    import stageSocket from './mixins/stageSocket'
    import finishLevelSocket from './mixins/finishLevelSocket'
    import StageWaiting from './StageWaiting.vue'
    import TrainerStageApi from "../../api/olympiads/trainerStageApi";

    export default {
        props: {
            id: [Number, String],
            isTrainer: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                stages: [],
                currentStage: null,
                games: null,
                currentGame: null,
                isLoading: true,
                level: null,
                timer: 0,
                timerId: null,
                isStarted: false,
                secondsToStartInterval: null,
                showFinishModal: false,
                levelTrainerStartTime: null,
            }
        },
        mixins: [stageSocket, finishLevelSocket],
        components: {
            GamesWrapper,
            OlympiadBox,
            OlympiadPreview,
            OlympiadPreviewWithDecorations,
            BrowseGames,
            FinishModal,
            StageWaiting
        },
        created () {
            this.fetchData();
            moment.locale(this.$i18n.locale);
        },
        watch: {
            games: {
                handler (games) {
                    if (games) {
                        this.setGame();
                    }
                },
                deep: true
            },
            isLevelCompleted (val) {
                if (val) {
                    if (!this.isTrainerAvailable && !this.isTrainer && this.level && !this.level.authCompletedUser.length) {
                        this.showAnimation();
                    }
                    this.completeLevel();
                }
            },
            timer () {
                let time = moment((this.isTrainer || this.isTrainerAvailable) ? this.levelTrainerStartTime : this.level.authRegisteredUser[0].pivot.startTime);
                if (moment().diff(time, 'minutes') >= this.level.duration && !this.isRealTime) {
                    this.completeLevel()
                    .then(() => {
                        if (this.isTrainer || this.isTrainerAvailable) {
                            this.startTrainerStagesAgain();
                        }
                        (!this.isTrainer && !this.isTrainerAvailable) && this.$router.back();
                        this.$toasted.info(this.$root.$t('olympiads.olympiads_finishLevelSocket_info'));
                    })
                    .catch(() => {
                        this.$router.back();
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    });
                }
            },
            isStarted (val) {
                if (val && this.currentGame) {
                    let mainColumn = document.querySelector('.main-column');
                    if (mainColumn && window.innerWidth < 576) {
                        mainColumn.style.padding = '0';
                    }
                }
            }
        },
        methods: {
            setGame () {
                if (!this.isRealTime || (this.currentStage && this.currentStage.isStarted)) {
                    this.currentGame = _.find(this.games, {isCompleted: 0});
                    this.currentGame ? this.isLoading = false : this.updateStage();
                } else {
                    this.isLoading = false;
                }
            },
            startTrainerStagesAgain () {
                this.$router.push({name: 'olympiads:show', params: {id: this.level.olympiad.id, isTrainer: true}});
            },
            completeLevel () {
                let form = {
                    isCompleted: true,
                    userId: this.user.id,
                    isTrainer: this.isTrainer || this.isTrainerAvailable,
                };
                return LevelApi.update(this.level.id, form)
                .catch(() => {
                    this.$toasted.error(this.$root.$t('errors.saving_results'));
                });
            },
            showAnimation () {
                this.$nextTick(() => {
                    this.showFinishModal = true;
                });
            },
            startGame () {
                this.isStarted = true;
                if ((this.isTrainer || this.isTrainerAvailable) && this.currentStage.position === 0 && this.currentGame.position === 0) {
                    this.levelTrainerStartTime = moment().format('YYYY-MM-DD HH:mm:ss');
                    this.setTimer();
                }
                if (!this.isTrainerAvailable && !this.isTrainer && this.currentStage.position === 0 && this.currentGame.position === 0 && !this.isRealTime) {
                    this.level.authRegisteredUser[0].pivot.startTime = moment().format('YYYY-MM-DD HH:mm:ss');
                    this.setTimer();
                }
            },
            updateStage () {
                if (!this.currentStage || this.currentStage.isCompleted) {
                    this.isLoading = false;
                    return;
                }
                let api = (this.isTrainer || this.isTrainerAvailable) ? TrainerStageApi : StageApi;
                setTimeout(() => {
                    api.update(this.currentStage.id, {isCompleted: true})
                    .then(() => {
                        this.currentStage.isCompleted = true;
                        this.isLoading = false;
                        if (this.stageFinished) {
                            setTimeout(() => {
                                this.$router.push({name: 'olympiads:stage-results', params: {id: this.currentStage.id, isTrainer: this.isTrainer || this.isTrainerAvailable}});
                            }, 1000);
                            this.stageFinished = false;
                        }
                    });
                }, 1500);
            },
            setParameters () {
                this.currentStage = _.find(this.stages, {isCompleted: 0});
                this.games = this.currentStage ? this.currentStage.games : [];
            },
            validate () {
                let user = this.level.authRegisteredUser[0];
                if (!user) {
                    this.$toasted.info(this.$i18n.t('errors.olympiads_startPage_notRegistered'));
                    this.$router.back();
                    return false;
                }
                return true;
            },
            fetchData () {
                LevelApi.show(this.id)
                .then(level => {
                    this.level = level;
                    if (!this.validate()) {
                        return;
                    }
                    if (this.isTrainer || this.isTrainerAvailable) {
                        level.stages.forEach(stage => {
                            stage.trainerStage.authCompletedUser = [];
                            this.stages.push(stage.trainerStage);
                        });
                        level.authCompletedUser = [];
                    } else {
                        this.stages = level.stages;
                    }
                    this.stages.forEach(stage => {
                        let allGamesAreCompleted = false;
                        if (this.isTrainer || this.isTrainerAvailable) {
                            allGamesAreCompleted = stage.games.every(game => game.isCompleted)
                        }
                        this.$set(stage, 'isCompleted', ((this.isTrainer || this.isTrainerAvailable) && allGamesAreCompleted) || stage.authCompletedUser.length || +stage.isEnded);
                    });
                    this.setParameters();
                    if (this.isRealTime && this.currentStage) {
                        this.startCounting();
                    }
                })
                .catch(err => {
                    if (err.data) {
                        this.$toasted.info(this.$root.$t(`errors.${err.data.message}`));
                        this.$router.back();
                    } else {
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                    }
                });
            },
            startCounting () {
                this.secondsToStartInterval = setInterval(() => {
                    this.stages.forEach(stage => {
                        stage.secondsToStart--;
                    });
                }, 1000);
            },
            finishExercise () {
                this.isLoading = true;
                this.isStarted = false;
                this.$nextTick(() => {
                    this.currentGame.isCompleted = true
                })
            },
            setTimer () {
                this.timerId = setInterval(() => {
                    this.timer++;
                }, 1000);
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            gameType() {
                if (this.currentGame.slug === 'Anzan' && this.currentGame.parameters.default.withTime) {
                    this.currentGame.slug = 'AnzanWithTime';
                }
                return this.currentGame.slug;
            },
            isTrainerAvailable () {
                if (this.level && this.level.authRegisteredUser[0] && this.level.isTrainerAvailable) {
                    let today = moment().format('YYYY-MM-DD');
                    let formattedStopDate = moment(this.level.stopTrainerDate).format('YYYY-MM-DD');
                    return moment(today).isSameOrBefore(formattedStopDate);
                }
                return false;
            },
            isLevelCompleted () {
                return this.stages && this.stages.every(stage => stage.isCompleted);
            },
            isRealTime () {
                return this.level && this.level.isRealTime;
            },
            timeToStart () {
                if (this.isRealTime && this.currentStage) {
                    let momentDuration = moment.duration(this.currentStage.secondsToStart, 'seconds');
                    let hours = momentDuration.hours();
                    let minutes = momentDuration.minutes();
                    let seconds = momentDuration.seconds();
                    let resultString = '';
                    if (hours) {
                        resultString += hours + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_hours', hours) + ' ';
                    }
                    if (minutes) {
                        resultString += minutes + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_minutes', minutes) + ' ';
                    }
                    resultString += seconds + ' ' + this.$i18n.tc('olympiads.olympiads_timeDeclination_seconds', seconds);
                    return resultString;
                }
                return null;
            }
        },
        beforeDestroy () {
            clearInterval(this.secondsToStartInterval);
            this.$store.dispatch('setGame', null);
        }
    }
</script>

<style lang="scss" scoped>
    .start-page {
        height: 100%;
    }

    .start-page__games-wrapper {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-40;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
        }
    }

    .trainer-wrapper {
        padding: 30px !important;
    }

    .start-page__olympiad-box {
        margin: 0 auto;
        @include media($lg) {
            width: 70%;
        }
    }

    .start-page__buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .start-page__buttons-container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .start-page__button {
        padding: 10px 20px !important;
        margin: 10px;
        width: fit-content;
        @include media($sm) {
            padding: 15px 30px !important;
            width: auto;
        }
    }

    .fade--enter-active, .fade--leave-active {
        transition: opacity .6s;
    }
    .fade--enter, .fade--leave-to {
        opacity: 0;
    }
    .fade--enter-to, .fade--leave {
        opacity: 1;
    }
</style>
